import type { AssetURLs, Attachment } from '../attachments';
import type { Category } from '../categories';
import type { Checkout } from '../checkouts';
import type { Comment } from '../comments';
import type { Customer } from '../customers';
import type { Flag } from '../groups';
import type { Kit } from '../kits';
import type { Location } from '../locations';

export type ItemKind = 'simple' | 'bulk';

export type ItemStatus =
	| 'available'
	| 'checkedout'
	| 'await_checkout'
	| 'in_transit'
	| 'maintenance'
	| 'repair'
	| 'inspection'
	| 'expired'
	| 'in_custody';

export type ItemAvailabilityStatus =
	| 'available'
	| 'unavailable_status'
	| 'unavailable_flag'
	| 'unavailable_allow'
	| 'unavailable_other';

export interface OrderQuantityWithKit {
	orderId: string;
	quantity: number;
	kitId?: string;
}

export interface Item {
	_id: string;
	category: Category;
	flag?: Flag;
	cover?: string | null;
	cover_url?: AssetURLs;
	barcodes: string[];
	fields: Record<string, string>;
	created: string;
	modified: string | null;
	name: string;
	codes: string[];
	rfidcodes: string[];
	status: ItemStatus;
	kind: ItemKind;
	itemTypeId: string;
	consumable: boolean;
	quantity: number;
	brand: string | null;
	model: string | null;
	warrantyDate: string | null;
	purchaseDate: string | null;
	purchasePrice: number | null;
	residualValue: number | null;
	depreciatedValue: number | null;
	address: string | null;
	expired: string | null;
	location: Location;
	locationPath?: Array<Location>;
	custody?: Customer;
	allowReserve: boolean;
	allowOrder: boolean;
	allowCustody: boolean;
	canReserve: ItemAvailabilityStatus;
	canOrder: ItemAvailabilityStatus;
	canCustody: ItemAvailabilityStatus;
	kitQuantities?: Record<string, number>;
	inKits?: number;
	isRestricted: boolean;
	kit?: Kit;
	/**
	 * @deprecated use orderQuantitiesWithKits instead
	 * @see orderQuantitiesWithKits
	 */
	order?: Checkout;
	/**
	 * @deprecated use orderQuantitiesWithKits instead
	 * @see orderQuantitiesWithKits
	 */
	orders?: Record<string, number>;
	orderQuantitiesWithKits?: OrderQuantityWithKit[];
	comments?: Comment[];
	attachments?: Attachment[];
}

export enum ItemConflict {
	AVAILABLE = 'AVAILABLE',
	ASSIGNED = 'ASSIGNED',
	CHECKED_OUT = 'CHECKED_OUT',
	CHECKING_OUT = 'CHECKING_OUT',
	RETIRED = 'RETIRED',
	FLAGGED = 'FLAGGED',
	RESERVED = 'RESERVED',
	UNAVAILABLE = 'UNAVAILABLE',
	CANNOT_RESERVE = 'CANNOT_RESERVE',
	CANNOT_CHECKOUT = 'CANNOT_CHECKOUT',
	AT_WRONG_LOCATION = 'AT_WRONG_LOCATION',
	UNAVAILABLE_QUANTITY = 'UNAVAILABLE_QUANTITY',
	INSUFFICIENT_QUANTITY = 'INSUFFICIENT_QUANTITY',
	RESTRICTED = 'RESTRICTED',
	UNAVAILABLE_TO_ADD_TO_KIT = 'UNAVAILABLE_TO_ADD_TO_KIT',
	INCOMPLETE_KIT = 'INCOMPLETE_KIT',
	INCOMPLETE_KIT_AVAILABILITY = 'INCOMPLETE_KIT_AVAILABILITY',
	BUFFER_TIME = 'BUFFER_TIME',
}

export type ConflictItem = {
	id: string;
	name: string;
	image: string;
	kind: 'BULK' | 'SIMPLE';
};
